package com.example.socialmediaapp.network

object NetworkConfig {
    /**
     * Base URL for the backend API.
     */
    var BASE_URL = "https://mytangle.ca"

    // Ensure the API_URL always ends with /api for consistency
    val API_URL get() = "https://mytangle.ca/api"
    
    val WS_URL get() = "wss://mytangle.ca/ws"
}
